import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from 'recharts';

import './BottomEmissionsRateBlock.scss';

interface BottomEmissionsRateBlockProps {
  graphData: any[];
  tableData: any[];
};

const BottomEmissionsRateBlock = (props: BottomEmissionsRateBlockProps) => {
  const blockNumber = props.tableData ? Math.ceil((props.tableData.length + 1) / 16.5) : 0;
  return (
    <div className='split-container-bottom-emissions'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart
            layout='vertical'
            margin={{left: 10, right: 40}}
            height={480}
            data={props.graphData}
          >
            <XAxis type='number' minTickGap={10} domain={[0, 100]} />
            <YAxis type='category' dataKey='name' width={100} />
            <Bar dataKey='value' fill='#75ced6' barSize={60} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table' style={{minHeight: blockNumber * 380}}>
        <table>
          <tr>
            <th style={{ width: '40%' }}>Customer Site</th>
            <th style={{ width: '20%' }}>Emissions Rate %</th>
            <th style={{ width: '20%' }}>Total Emissions, t</th>
            <th style={{ width: '20%' }}>Total Waste, t</th>
          </tr>
          {props.tableData.map((er, idx) =>
            <tr key={'top-er-export-' + idx} className={idx < 5 ? 'top-five-rows' : ''}>
              <td style={{ width: '40%' }}>{er[0]}</td>
              <td style={{ width: '20%' }}>{er[1]}</td>
              <td style={{ width: '20%' }}>{er[2]}</td>
              <td style={{ width: '20%' }}>{er[3]}</td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default BottomEmissionsRateBlock;